import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f9859f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-actions-detail" }

import { computed, PropType, ref } from 'vue';
import {
  TaskStatusDropdown,
  TaskPriorityDropdown,
  TaskTypeDropdown,
  TaskDifficultyDropdown,
  TaskDeadline,
  TaskTimeTracker,
  TimeTrackerCreateRecordModel,
  TimerTrackerEditRecordModel,
  TimeTrackerRecordModel,
  TaskTimeEstimate,
} from '../../components';
import {
  DifficultyModel,
  PerformerEstimatedModel,
  PriorityModel,
  StatusModel,
  TypeModel,
} from '../../models';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from './models/GetAccessCurrentUserInQueueTaskByIdResponseModel';


export default /*#__PURE__*/_defineComponent({
  __name: 'task-actions-detail',
  props: {
  /**Доступы юзера к очереди */
  userAccess: { type: Object as PropType<GetAccessCurrentUserInQueueTaskByIdResponseModel> },
  /**Режим редактирования */
  isEditMode: {
    type: Boolean,
    default: false,
  },
  /**Отключить таймер */
  isDisabledTimer: {
    type: Boolean,
    default: false,
  },

  /**Выбранный статус */
  selectedStatus: {
    type: Number,
  },
  /**Выбранный приоритет */
  selectedPriority: {
    type: Number,
  },
  /**Выбранная сложность */
  selectedDifficulty: {
    type: String,
  },
  /**Выбранный тип */
  selectedType: {
    type: String,
  },
  /**Дата дедлайна */
  deadlineDate: {
    type: Date,
    default: new Date(),
  },
  /**Дата старта таймера */
  timerStartDate: {
    type: Date,
  },
  /**Загрузка таймера */
  isLoadingTimer: {
    type: Boolean,
    default: false,
  },
  /**Загрузка оценки */
  isLoadingEstimate: {
    type: Boolean,
    default: false,
  },
  /**разрешить редактирование */
  editing: {
    type: Boolean,
    default: true,
  },

  /**Список статусов */
  statuses: {
    type: Array as PropType<Array<StatusModel>>,
    default: [],
  },
  /**Список приоритетов */
  priorities: {
    type: Array as PropType<Array<PriorityModel>>,
    default: [],
  },
  /**Список уровней сложности */
  difficultyList: {
    type: Array as PropType<Array<DifficultyModel>>,
    default: [],
  },
  /**Список типов */
  typeList: {
    type: Array as PropType<Array<TypeModel>>,
    default: [],
  },
  /**Записи таймера */
  timerRecords: {
    type: Array as PropType<Array<TimeTrackerRecordModel>>,
    default: [],
  },
  /**Список оценок по исполнителям */
  performersEstimated: {
    type: Array as PropType<Array<PerformerEstimatedModel>>,
    default: [],
  },
  /**Id задачи */
  taskId: { type: Number },
  /**Может ли текущий пользователь выставлять итоговую оценку времени */
  canUpsertFinalEstimate: { type: Boolean },
  /**Финальная оценка */
  finalEstimatePerformer: { type: Object as PropType<PerformerEstimatedModel> },
  /**Оценка задачи */
  isEstimate: { type: Boolean },
  /**Разрешено редактирование статуса */
  allowStatusChange: { type: Boolean },
  /**Текущий пользователь является исполнителем */
  isPerformer: { type: Boolean },
},
  emits: ["update:selectedStatus", "update:selectedPriority", "update:selectedDifficulty", "update:selectedType", "update:deadlineDate", "onStartTimer", "onStopTimer", "onCreateTimerRecord", "onDeleteTimerRecord", "onEditTimerRecord", "updateTimer"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;





/**Ссылка на компонент таймера */
const $timeTracker = ref<InstanceType<typeof TaskTimeTracker>>();
/**Ссылка на компонент оценки времени */
const $timeEstimate = ref<InstanceType<typeof TaskTimeEstimate>>();

/**Отключено ли редактирование статуса */
const statusDisabled = computed(() => !props.editing && !props.allowStatusChange);
/**Отключен учет времени */
const isTimeTrackerDisabled = computed(
  () => (!props.isEditMode || props.isDisabledTimer || !props.editing) && !props.isPerformer,
);

/**Код для использования по ref */
__expose({
  $timeTracker,
  $timeEstimate,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TaskStatusDropdown), {
      "model-value": __props.selectedStatus,
      options: __props.statuses,
      "is-disabled": statusDisabled.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:selectedStatus', $event)))
    }, null, 8, ["model-value", "options", "is-disabled"]),
    _createVNode(_unref(TaskPriorityDropdown), {
      "model-value": __props.selectedPriority,
      options: __props.priorities,
      "is-disabled": !__props.editing,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:selectedPriority', $event)))
    }, null, 8, ["model-value", "options", "is-disabled"]),
    _createVNode(_unref(TaskDifficultyDropdown), {
      "model-value": __props.selectedDifficulty,
      options: __props.difficultyList,
      "is-disabled": !__props.editing,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (emit('update:selectedDifficulty', $event)))
    }, null, 8, ["model-value", "options", "is-disabled"]),
    _createVNode(_unref(TaskTypeDropdown), {
      "model-value": __props.selectedType,
      options: __props.typeList,
      "is-disabled": !__props.editing,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (emit('update:selectedType', $event)))
    }, null, 8, ["model-value", "options", "is-disabled"]),
    _createVNode(_unref(TaskDeadline), {
      "model-value": __props.deadlineDate,
      editing: __props.editing,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (emit('update:deadlineDate', $event)))
    }, null, 8, ["model-value", "editing"]),
    _createVNode(_unref(TaskTimeTracker), {
      ref_key: "$timeTracker",
      ref: $timeTracker,
      userAccess: __props.userAccess,
      records: __props.timerRecords,
      "timer-start-date": __props.timerStartDate,
      "is-loading": __props.isLoadingTimer,
      "is-disabled": isTimeTrackerDisabled.value,
      width: "100%",
      onOnStart: _cache[5] || (_cache[5] = ($event: any) => (emit('onStartTimer', $event))),
      onUpdateTimer: _cache[6] || (_cache[6] = ($event: any) => (emit('updateTimer', $event))),
      onOnStop: _cache[7] || (_cache[7] = ($event: any) => (emit('onStopTimer'))),
      onOnCreateRecord: _cache[8] || (_cache[8] = ($event: any) => (emit('onCreateTimerRecord', $event))),
      onOnDeleteRecord: _cache[9] || (_cache[9] = ($event: any) => (emit('onDeleteTimerRecord', $event))),
      onOnEditRecord: _cache[10] || (_cache[10] = ($event: any) => (emit('onEditTimerRecord', $event)))
    }, null, 8, ["userAccess", "records", "timer-start-date", "is-loading", "is-disabled"]),
    _createVNode(_unref(TaskTimeEstimate), {
      ref_key: "$timeEstimate",
      ref: $timeEstimate,
      userAccess: __props.userAccess,
      "performers-estimated": __props.performersEstimated,
      "is-disabled": !__props.isEditMode,
      "is-loading": __props.isLoadingEstimate,
      taskId: __props.taskId,
      canUpsertFinalEstimate: __props.canUpsertFinalEstimate,
      finalEstimatePerformer: __props.finalEstimatePerformer,
      isEstimate: __props.isEstimate
    }, null, 8, ["userAccess", "performers-estimated", "is-disabled", "is-loading", "taskId", "canUpsertFinalEstimate", "finalEstimatePerformer", "isEstimate"])
  ]))
}
}

})